import React from "react";

const WebsitePolicies = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Website Policies</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <ol>
          <li>
            <h6>Copyright Policy</h6>
            <p>
              All copyrights are reserved with the Haryana Seeds Development
              Corporation LTD. The material posted on the website may be
              reproduced without formal permission for the purposes of
              non-commercial research, private study, review and news reporting
              provided that the same is appropriately attributed. For any other
              purposes, one is required to obtain permission by sending a mail.
              Under Section 2 (k) of the Copyright Act, 1957, the copyright for
              the reproduction of any material from the debates and ancillary
              publications vests with the Haryana Seeds Development Corporation
              LTD. A member of the assembly desirous of reproducing any material
              from the Legislative Assembly debates or even his own speeches is
              required to seek formal permission from the Speaker giving
              specific details of the matter to be reproduced. The Editorial
              Branch of RLA Secretariat is responsible for the examination of
              copyright matters.
            </p>
          </li>
          <hr/>
          <li>
            <h6>Privacy Policy</h6>
            <p>
              This website does not automatically capture any specific personal
              information from you (like name, phone number or e-mail address),
              that allows us to identify you individually. If you choose to
              provide us with your personal information, like names or
              addresses, when you visit our website, we use it only to fulfill
              your request for information. To use the Interact with Haryana
              State Legal Services Authority, this website requires user
              registration. Information so collected is used to facilitate
              interaction.
            </p>
            <p>
              We do not sell or share any personally identifiable information
              volunteered on this site to any third party (public/private). Any
              information provided to this website will be protected from loss,
              misuse, unauthorized access or disclosure, alteration, or
              destruction.
            </p>
            <p>
              We gather certain information about the User, such as Internet
              protocol (IP) address, domain name, browser type, operating
              system, the date and time of the visit and the pages visited. We
              make no attempt to link these addresses with the identity of
              individuals visiting our site unless an attempt to damage the site
              has been detected.
            </p>
          </li>
          <hr/>
          <li>
            <h6>Hyperlink Policy</h6>
            <p> <strong>Links to external websites/portals</strong></p>

            <p>
              At many places in this website, you shall find links to other
              websites/portals. The links have been placed for your convenience.
              Haryana State Legal Services Authority is not responsible for the
              contents and reliability of the linked websites and does not
              necessarily endorse the views expressed in them. Mere presence of
              the link or its listing on this Portal should not be assumed as
              endorsement of any kind. We cannot guarantee that these links will
              work all the time and we have no control over availability of
              linked pages.
            </p>

            <p>
            <strong> Links to Haryana Seeds Development Corporation Ltd Website by
              other websites/portals</strong>
            </p>

            <p>
              Prior permission is required before hyperlinks are directed from
              any website/portal to this site. Permission for the same, stating
              the nature of the content on the pages from where the link has to
              be given and the exact language of the Hyperlink should be
              obtained by sending a request to stake holder
            </p>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default WebsitePolicies;
